module.exports = __webpack_public_path__ + "img/universal_cancel.b22a4dc9.svg";